import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import "./ProjectVideos.css";
import DashSideBar from "../../shared/DashSideBar";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";

function ProjectVideos() {
  let emptyProjectVideo = {
    id: null,
    name: "",
    description: "",
    videoUrl: null,
    sliderPosition: null,
    sortOrder: null,
    project: { id: null, name: "" },
  };

  const [projectVideos, setProjectVideos] = useState(null);
  const [projects, setProjects] = useState(null);
  const [projectVideoDialog, setProjectVideoDialog] = useState(false);
  const [deleteProjectVideoDialog, setDeleteProjectVideoDialog] =
    useState(false);
  const [deletProjectVideosDialog, setDeletProjectVideosDialog] =
    useState(false);
  const [projectVideo, setProjectVideo] = useState(emptyProjectVideo);
  const [selectedProjectVideos, setSelectedProjectVideos] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    getProjectVideos();
    getProjects();
  }, []);

  const getProjectVideos = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/projectVideos"
      );

      if (response.data) {
        setProjectVideos(response.data);
      }
    } catch (error) {
      console.error("Error fetching projectVideos:", error);
    }
  };
  const getProjects = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL +
          "api/Projects/GetProjectsForProjectMaterials"
      );

      if (response.data) {
        setProjects(response.data);
      }
    } catch (error) {
      console.error("Error fetching projectVideos:", error);
    }
  };

  const openNew = () => {
    setProjectVideo(emptyProjectVideo);
    setSubmitted(false);
    setProjectVideoDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setProjectVideoDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProjectVideoDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeletProjectVideosDialog(false);
  };

  const saveProjectVideo = async () => {
    setLoading(true);
    setSubmitted(true);

    if (projectVideo.name.trim()) {
      let _projectVideos = [...projectVideos];
      let _projectVideo = { ...projectVideo };

      if (projectVideo.id) {
        const index = findIndexById(projectVideo.id);

        let formData = new FormData();
        formData.append("name", _projectVideo.name);
        formData.append("description", _projectVideo.description);
        formData.append("sortOrder", _projectVideo.sortOrder);
        formData.append("sliderPosition", _projectVideo.sliderPosition);
        formData.append("projectId", _projectVideo.project.id);
        if (file != null) {
          formData.append("VideoUrl", file);
        }
        const response = await axios.put(
          process.env.REACT_APP_BACKEND_URL +
            "api/projectVideos/" +
            projectVideo.id,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        setLoading(false);
        setFile(null);
        if (response.data.success) {
          _projectVideos[index] = _projectVideo;
          if (response.data.fileName !== "")
            _projectVideos[index].VideoUrl = response.data.fileName;
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Video Updated",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Video Not Updated",
            life: 3000,
          });
        }
      } else {
        _projectVideo.id = createId();
        let formData = new FormData();
        formData.append("name", _projectVideo.name);
        formData.append("description", _projectVideo.description);
        formData.append("sortOrder", _projectVideo.sortOrder);
        formData.append("sliderPosition", _projectVideo.sliderPosition);
        formData.append("projectId", _projectVideo.project.id);
        formData.append("VideoUrl", file);

        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "api/projectVideos",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        setLoading(false);
        setFile(null);

        if (response.data.success) {
          _projectVideos.push(response.data.projectVideo);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Video Added",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Video Not Added",
            life: 3000,
          });
        }
      }

      setProjectVideos(_projectVideos);
      setProjectVideoDialog(false);
      setProjectVideo(emptyProjectVideo);
    }
  };

  const editProduct = (projectVideo) => {
    setProjectVideo({ ...projectVideo });
    setProjectVideoDialog(true);
  };

  const confirmDeleteProduct = (projectVideo) => {
    setProjectVideo(projectVideo);
    setDeleteProjectVideoDialog(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_URL + "api/projectVideos/" + projectVideo.id
    );
    setLoading(false);
    if (response.data.success) {
      let _projectVideos = projectVideos.filter(
        (val) => val.id !== projectVideo.id
      );
      setProjectVideos(_projectVideos);
      setDeleteProjectVideoDialog(false);
      setProjectVideo(emptyProjectVideo);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Project Video Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Project Video Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < projectVideos.length; i++) {
      if (projectVideos[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  // const VideoBodyTemplate = (rowData) => {
  //   return (
  //     <img
  //       src={process.env.REACT_APP_BACKEND_URL_Videos + rowData.VideoUrl}
  //       alt={rowData.VideoUrl}
  //       className="shadow-2 border-round"
  //       style={{ width: "64px" }}
  //     />
  //   );
  // };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeletProjectVideosDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedProjectVideos.map((projectVideo) => projectVideo.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL +
        "api/projectVideos/DeleteProjectVideosByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _projectVideos = projectVideos.filter(
        (val) => !selectedProjectVideos.includes(val)
      );
      setProjectVideos(_projectVideos);
      setDeletProjectVideosDialog(false);
      setSelectedProjectVideos(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "project Videos Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "project Videos Not Deleted",
        life: 3000,
      });
    }
  };

  const onProjectChange = (selectedOption) => {
    const selectedProjectId = selectedOption.value; // Assuming 'value' contains the selected category ID

    const selectedProject = projects.find(
      (project) => project.id === selectedProjectId
    );
    setProjectVideo({
      ...projectVideo,
      project: { id: selectedOption.value, name: selectedProject.name },
    });
  };
  const onSliderPositionChange = (e) => {
    setProjectVideo({
      ...projectVideo,
      sliderPosition: e.value, // e.value will now be 0 or 1
    });
  };

  const onFileUpload = (event) => {
    const file = event.files[0];
    setFile(file);

    setProjectVideo((prevProjectVideo) => ({
      ...prevProjectVideo,
      VideoUrl: process.env.REACT_APP_BACKEND_URL_Videos + file.name, // Save the file name as the Video path for simplicity
    }));
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _projectVideo = { ...projectVideo };

    _projectVideo[`${name}`] = val;

    setProjectVideo(_projectVideo);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Project Videos</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedProjectVideos || !selectedProjectVideos.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Project Videos</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        loading={loading}
        icon="pi pi-check"
        onClick={saveProjectVideo}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="projectVideo-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={projectVideos}
              selection={selectedProjectVideos}
              onSelectionChange={(e) => setSelectedProjectVideos(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Project Videos"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="name"
                header="Name"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>

              <Column
                field="description"
                header="Description"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="sortOrder"
                sortable
                header="Order"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="sliderPosition"
                sortable
                header="Slider Video Position"
                style={{ textAlign: "center" }}
                body={(rowData) => {
                  // Check the value of sliderPosition and return the appropriate label
                  return rowData.sliderPosition === 0
                    ? "Main Slider"
                    : "Second Slider";
                }}
              ></Column>

              <Column
                field="project.name"
                header="Project"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={projectVideoDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Project Video Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="name" className="font-bold mb-1">
                Name :
              </label>
              <InputText
                id="name"
                value={projectVideo.name}
                onChange={(e) => onInputChange(e, "name")}
                required
                autoFocus
                className={classNames({
                  "p-invalid": submitted && !projectVideo.name,
                })}
              />
              {submitted && !projectVideo.name && (
                <small className="p-error">Name is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="description" className="font-bold mt-3 mb-1">
                Description :
              </label>
              <InputTextarea
                id="description"
                value={projectVideo.description}
                onChange={(e) => onInputChange(e, "description")}
                required
                autoFocus
                className={classNames({
                  "p-invalid": submitted && !projectVideo.description,
                })}
              />
              {submitted && !projectVideo.alt && (
                <small className="p-error">Description is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={projectVideo.sortOrder}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !projectVideo.sortOrder,
                })}
              />
              {submitted && !projectVideo.sortOrder && (
                <small className="p-error">sortOrder is required.</small>
              )}
            </div>
            <div className="field">
              <label className="mb-3 font-bold">Slider Position</label>
              <Dropdown
                value={projectVideo.sliderPosition}
                options={[
                  { value: 0, label: "Main Slider" }, // MainSlider as 0
                  { value: 1, label: "Second Slider" }, // SecondSlider as 1
                ]}
                onChange={onSliderPositionChange}
                placeholder="Select a Slider Position"
              />
            </div>
            <div className="field">
              <label className="mb-3 font-bold">Porject</label>
              {projects != null ? (
                <Dropdown
                  value={projectVideo.project.id}
                  options={projects.map((project) => ({
                    value: project.id,
                    label: project.name,
                  }))}
                  onChange={onProjectChange}
                  placeholder="Select a Project"
                />
              ) : (
                <p>Loading projects...</p>
              )}
            </div>

            <div className="field">
              <label htmlFor="Video" className="mb-3 font-bold">
                Video
              </label>
              <FileUpload
                name="Video"
                mode="basic"
                accept="video/*,video/mp4,video/mov"
                // Adjust the maximum file size as needed
                onSelect={onFileUpload}
              />
            </div>
          </Dialog>

          <Dialog
            visible={deleteProjectVideoDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {projectVideo && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{projectVideo.name}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={deletProjectVideosDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {projectVideo && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected projects?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default ProjectVideos;
